import path from 'utils/path';
import checkAccess from 'utils/roles/checkAccess';
import getFranchiseRegion from 'utils/jwt/getFranchiseRegion';

export const routerPath = {
  root: '/vendors',
  link: '/shop/vendors',
  goProducts: ({ id, vendorName }) => path(id, `/products?vendorName=${vendorName}`),
  goProductsVendorAdmin: '/shop/vendors/null/products',
};

export const getColumns = ({ editItem, goProducts }) => [
  {
    id: 'imageId',
    type: 'avatar',
    label: 'Avatar',
    align: 'center',
    disableSort: 'true',
  },
  { id: 'name', label: 'Vendor', align: 'center', nameForSort: 'name' },
  { id: 'region', label: 'Region', align: 'center', nameForSort: 'region' },
  { id: 'contactNumber', label: 'Contact Num', align: 'center', nameForSort: 'contact_number' },
  { id: 'contactPerson', label: 'Contact Person', align: 'center', nameForSort: 'contact_person' },
  {
    id: 'isActive',
    label: 'Status',
    customValue: (val) => (val.isActive ? 'Active' : 'Inactive'),
    align: 'center',
    nameForSort: 'is_active',
  },
  {
    id: 'more-menu',
    type: 'menu',
    items: [
      { id: 1, name: 'Edit', action: editItem, icon: 'eva:edit-fill' },
      {
        id: 2,
        name: 'Products',
        action: goProducts,
        icon: 'mdi:text-box-multiple-outline',
      },
    ],
    disableSort: true,
  },
];

export const getFilters = ({ region, active, options }) => [
  {
    id: 'region',
    type: 'select',
    label: 'Region',
    value: checkAccess([2]) ? getFranchiseRegion() : region.value,
    action: region.change,
    items: options?.regions?.length ? ['all', ...options.regions] : ['all'],
    disabledEdit: checkAccess([2]),
  },
  {
    id: 'active',
    type: 'switch',
    label: 'Active',
    value: active.value === 'true',
    action: active.change,
  },
];
